import { useMemo, useState } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Breadcrumbs, CommonSelect } from "components/Common/Common";
import ReportsComponent from "./ReportsComponent";
import { getClientBreadCrumbs, userFullName } from "helpers/common";

const ReportsPage = ({ client_id, module, heading = "Notes", buttonName = "Create Note" }) => {
    const navigate = useNavigate()
    const { clientId, moduleName, clientType } = useParams()
    const [clientDetails, setClientDetails] = useState(null)
    const [filter, setFilter] = useState({ status: "" })

    const breadcrumbItems = useMemo(() => getClientBreadCrumbs(clientId, clientType, clientDetails, "All Reports"), [clientType, clientDetails, clientId]);

    const handleFilterChange = (key) => (value) => {
        setFilter({ ...filter, [key]: value })
    };

    return (
        <>
            <section
                className={`position-relative ClientDetail`}
            >
                <Container fluid>
                    <Row style={{ paddingLeft: '12px' }} className="pt-3">
                        <Col lg="6">
                            <Breadcrumbs themeBlueV2 items={breadcrumbItems} />
                        </Col>
                    </Row>
                    <div className="mt-2">
                        <ReportsComponent setClientDetails={setClientDetails} statusFilter={filter?.status} clientId={clientId} clientType={clientType} isPage={true} />
                    </div>
                </Container>
            </section>
        </>
    );

};

export default ReportsPage;